import React, { Fragment } from 'react'
import FloatingContainer from '../../components/global/floatingContainer'
import SignUpFields from './signUpFields'
import Introduction2 from '../../components/global/introduction2'

const SignUp = () => {
    return (
        <Fragment>
            <Introduction2
                children={
                    <FloatingContainer
                        children={
                            <SignUpFields />
                        }
                    />
                }
            />
        </Fragment>
    )
}

export default SignUp